export const WISHLIST = 'wishlist';

export const ADDED_TO_WISHLIST_MESSAGE = 'Added to Wishlist';
export const REMOVED_FROM_WISHLIST_MESSAGE = 'Removed from wishlist';
export const REMOVE_PRODUCT_FROM_WISHLIST_FAILED = 'Something went wrong!';
export const ADD_PRODUCT_TO_WISHLIST_FAILED = 'Something went wrong!';

export const PRODUCT_TO_ADD_TO_WISHLIST = 'PRODUCT_TO_ADD_TO_WISHLIST';
export const STORE_ID_FOR_WISHLIST_AFTER_LOGIN = 'STORE_ID_FOR_WISHLIST_AFTER_LOGIN';
export const ITEM_REMOVED_FROM_WISHLIST = 'Item removed from wishlist';
export const ITEM_ADDED_TO_WISHLIST = 'Item added to your wishlist!';